import { selectCommand, selectNtpSearchCount } from './basic';
import { GlobalState } from '../../../../types.global';
import { getShortcutList } from '../../components/Shortcut';
import { selectFeatureFlags } from '../../../../store/selectors';

export const LIST = [
  {
    id: 1,
    text: 'You can search directly on your favorite websites. Just typing their name in the search box. Try typing youtube.',
  },
  {
    id: 2,
    text: 'You can change the background pictures in the bottom right corner.',
  },
  {
    id: 3,
    text: 'In case opening tabs feels slow, try turning off background pictures.',
  },
  {
    id: 4,
    text: (state: GlobalState): string => {
      const command = selectCommand(state);
      if (!command?.shortcut) return null;

      const shortcut = getShortcutList(command.shortcut).join(' + ');
      if (!shortcut) return null;
      return `You can also use the shortcut ${shortcut} to use our search bar.`;
    },
  },
];

export const selectActiveHintId = (state: GlobalState): number => {
  const { MAGIC_SEARCH_BOX } = selectFeatureFlags(state);

  if (!MAGIC_SEARCH_BOX || state.search.isSubmitted) return null;

  const searchCount = selectNtpSearchCount(state);
  if (!searchCount || searchCount % 4) return null;

  const remaining = LIST.filter(
    ({ id }) => !state.search.hints.history.includes(id)
  );

  return remaining[0]?.id || null;

  // every 4 searches, display next hint and rotate them
  // const { length } = remaining;
  // const index = ((searchCount - length) / length) % length;
  // return remaining[index] ? LIST.indexOf(remaining[index]) : null;
};

export const selectActiveHint = (state: GlobalState): string => {
  const activeHintId = selectActiveHintId(state);
  const result = activeHintId
    ? LIST.find(({ id }) => id === activeHintId)?.text
    : null;
  return typeof result === 'function' ? result(state) : result;
};
